<script lang="ts" setup>
import type { NavigationMenuItem } from '@nuxt/ui';
import { useMerchantSlugMaybeStatic } from '~/composables/useMerchantSlugMaybeStatic';
import { insertIf } from '~/utils';
import type { PublicMerchant } from '~~/models/Merchant';

const props = defineProps<{
	merchant: PublicMerchant;
}>();

const merchantSlugMaybeStatic = useMerchantSlugMaybeStatic(toRef(() => props.merchant.slug));

const { t } = useI18n();

const footerLinks = computed<NavigationMenuItem[]>(() => {
	return [
		{
			label: t('button.imprint'),
			to: t('link.imprint'),
			target: '_blank',
		},
		{
			label: t('button.privacyPolicy'),
			to: merchantSlugMaybeStatic.value ? { name: 'MerchantContentPage', params: { slug: 'privacy', merchantSlug: merchantSlugMaybeStatic.value } } : t('link.privacyPolicy'),
			target: '_blank',
		},
		{
			label: t('button.tos'),
			to: merchantSlugMaybeStatic.value ? { name: 'MerchantContentPage', params: { slug: 'terms_of_use', merchantSlug: merchantSlugMaybeStatic.value } } : t('link.tos'),
			target: '_blank',
		},
		...insertIf<NavigationMenuItem>(props.merchant.slug, {
			label: t('footer.links.v1signin'),
			to: { name: 'MerchantV1Redirect', params: { merchantSlug: props.merchant.slug } },
			target: '_blank',
		}),
	];
});
</script>

<template>
	<div class="flex items-end gap-3 lg:justify-center mt-8 flex-1 flex-wrap">
		<NuxtLink
			v-for="item in footerLinks"
			:key="item.label"
			:to="item.to"
			:target="item.target"
			class="text-sm text-dimmed hover:underline"
		>
			{{ item.label }}
		</NuxtLink>
	</div>
</template>
